import { graphql } from '../gql';

export const MARK_AS_RENEWAL_IN_PROGRESS = graphql(`
  mutation markAsRenewalInProgress($uuid: UUID!) {
    markAsRenewalInProgress(uuid: $uuid) {
      ok
    }
  }
`);
